export default [
  {
    path: 'home',
    name: 'home',
    component: () => import('./index'),
    meta: {
      visible: false,
      title: 'Home'
    }
  }
]